import { TZDate } from '@date-fns/tz';
import { MESSAGE_TYPE } from '../api/ws.types';

const months = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

export const formatMessageTime = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp * 1000);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
};

export const formatMessageDate = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp * 1000);
  return `${date.getDate()} ${months[date.getMonth()]}`;
};

export const formatChatLastDate = (timestamp) => {
  if (!timestamp) return null;
  const d = new Date(timestamp * 1000);
  const today = new Date();
  const tdStr = today.toLocaleDateString();
  const str = d.toLocaleDateString();
  if (str === tdStr) {
    return d.toLocaleTimeString().split(':').slice(0, 2).join(':');
  }
  return str;
};

export const groupMessagesByDate = (messages) => {
  if (!messages || messages.length === 0) return [];
  const groups = [];
  let currentDate = null;

  // messages приходят от старых к новым (или наоборот, в зависимости от WS)
  // В текущей реализации messageHistory = [новое, ..., старое] (reverse order)
  // Поэтому итерируем как есть
  for (const msg of messages) {
    const date = formatMessageDate(msg.timestamp);
    if (date !== currentDate) {
      currentDate = date;
      groups.push({ date, messages: [] });
    }
    groups[groups.length - 1].messages.push(msg);
  }
  return groups;
};

const INTERACTIVE_MESSAGE_LABELS = {
  [MESSAGE_TYPE.SLOT_OFFER]: 'Предложение занятия',
  [MESSAGE_TYPE.APPOINTMENT_CARD]: 'Занятие',
  [MESSAGE_TYPE.PACKAGE_CARD]: 'Пакет занятий',
  [MESSAGE_TYPE.PACKAGE_OFFER_CARD]: 'Предложение пакета',
};

// Интерактивное сообщение — не текст, а карточка (предложение слота/пакета, сущность)
export const isInteractiveMessage = (message) =>
  !!message?.type && message.type !== MESSAGE_TYPE.TEXT;

// Короткий текст для списка чатов и тостов.
// Для карточек берём готовый заголовок из card (уже отформатирован на бэке).
export const getMessagePreview = (message) => {
  if (!message) return '';
  if (message.card?.title) return message.card.title;
  if (isInteractiveMessage(message)) {
    return INTERACTIVE_MESSAGE_LABELS[message.type] || 'Интерактивное сообщение';
  }
  if (message.data) return message.data;
  if (message.attachments?.length) return 'Вложение';
  return '';
};

// Человекочитаемый текст для интерактивного сообщения
export const getInteractiveMessageLabel = (type) =>
  INTERACTIVE_MESSAGE_LABELS[type] || 'Интерактивное сообщение';

// Человекочитаемые лейблы статуса карточки (card.status)
const CARD_STATUS_LABELS = {
  cancelled: 'Отменено',
  canceled: 'Отменено',
  done: 'Завершено',
  completed: 'Завершено',
  expired: 'Истёк срок',
  pending: 'Ожидает',
};

export const getCardStatusLabel = (status) =>
  CARD_STATUS_LABELS[status] || status;

// Форматирование даты слота ("2026-09-23" или "23.09.2026" -> "23 сентября").
// Дату без времени парсим по компонентам, чтобы таймзона браузера не сдвинула
// день; при переданной таймзоне считаем в ней.
export const formatSlotDate = (dateStr, timezone) => {
  if (!dateStr) return '';
  const parts = String(dateStr).split(/[./-]/).map(Number);
  let date;
  if (parts.length === 3 && parts.every((n) => !Number.isNaN(n))) {
    const [a, b, c] = parts;
    // год первым (ISO) или последним (dd.MM.yyyy)
    const [year, month, day] = a > 31 ? [a, b, c] : [c, b, a];
    date = timezone
      ? new TZDate(year, month - 1, day, timezone)
      : new Date(year, month - 1, day);
  } else {
    date = timezone ? new TZDate(dateStr, timezone) : new Date(dateStr);
  }
  if (Number.isNaN(date.getTime())) return String(dateStr);
  return `${date.getDate()} ${months[date.getMonth()]}`;
};
